import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form } from "../../components/Form";
import { Autocomplete, AutocompleteMulti } from "../../components/Autocomplete";
import { BasePaper, Row } from "../../components/Base";
import Button from "../../components/Button";
import {
  createAssociationPositionProcessStep,
  updateAssociationPositionProcessStep,
  getAssociationPositionProcessStepById,
} from "../../api/associate-operation-process-step";
import { getOperations } from "../../api/operations";
import { getProcessStep } from "../../api/process-step";

const EditProcessStep = ({ match, history }) => {
  const { t } = useTranslation();
  const { associateOperationProcessStepId } = match.params;
  const isAdd = !associateOperationProcessStepId;
  const [loaded, setLoaded] = useState(false);
  const [Operation, setOperation] = useState("");
  const [selectedOperation, setSelectedOperation] = useState("");
  const [processStep, setProcessStep] = useState(null);
  const [selectedProcessStep, setSelectedProcessStep] = useState();

  useEffect(() => {
    (async () => {
      const operationRes = await getOperations();
      setOperation(operationRes);
      const processStepRes = await getProcessStep();
      setProcessStep(processStepRes);

      if (associateOperationProcessStepId) {
        const associationPositionProcessStep = await getAssociationPositionProcessStepById(
          associateOperationProcessStepId,
        );
        const operationReturn = operationRes.find((c) => c.id === associationPositionProcessStep[0].operationId);
        setSelectedOperation(operationReturn);
        const processStepIds = associationPositionProcessStep[0].data.map((item) => item.processStepId);
        const processStepReturn = processStepRes.filter((c) => processStepIds.includes(c.id));
        setSelectedProcessStep(processStepReturn);
      }
      setLoaded(true);
    })();
  }, [associateOperationProcessStepId]);

  const goBack = () => history.goBack();

  const onSubmit = async (values) => {
    const operationId = selectedOperation.id;
    const processStepIds = selectedProcessStep.map((c) => c.id);

    let result;
    if (isAdd) {
      result = await createAssociationPositionProcessStep(operationId, processStepIds);
    } else {
      result = await updateAssociationPositionProcessStep(operationId, processStepIds);
    }
    if (result.ok) {
      history.push("/associate-operation-process-step");
    }
  };

  const title = isAdd ? t("associate_process_step.add_title") : t("associate_process_step.edit_title");

  return (
    <>
      <Typography variant="h4">
        <Button icon={<ArrowBackIcon />} onClick={goBack} />
        {title}
      </Typography>
      {loaded ? (
        <BasePaper>
          <Form onSubmit={onSubmit}>
            <Row>
              <Autocomplete
                label={t("operations")}
                options={Operation}
                value={selectedOperation}
                onChange={(items) => {
                  setSelectedOperation(items);
                }}
              />
            </Row>
            <Row>
              <AutocompleteMulti
                label={t("associate_process_step.process_step_list")}
                options={processStep}
                value={selectedProcessStep}
                onChange={(items) => {
                  setSelectedProcessStep(items);
                }}
              />
            </Row>
            <Row>
              <Button type="submit">{t("save")}</Button>
              <Button onClick={goBack}>{t("cancel")}</Button>
            </Row>
          </Form>
        </BasePaper>
      ) : null}
    </>
  );
};

export default EditProcessStep;
